import { provideZoneChangeDetection } from '@angular/core';
/// <reference types="@angular/localize" />

// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { Routes } from '@angular/router';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { routesNew } from './app/app.routes';
import 'moment/locale/it';
import { environment } from './environments/environment';

registerLocaleData(localeIt);

const routes: Routes = [...routesNew];

// --------------------------------------------------------------------------------------

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideClientHydration(),
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
